import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Tach code theo route: khach vao 1 trang khong con phai tai JS cua 3
// trang con lai. Truoc day ca 4 trang gop chung 1 file 128.68 KB gzip.
const HomePage = lazy(() => import("./pages/HomePage"));
const CarInsurance = lazy(() => import("./pages/CarInsurance"));
const AccidentInsurance = lazy(() => import("./pages/AccidentInsurance"));
const PropertyInsurance = lazy(() => import("./pages/PropertyInsurance"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/car-insurance" element={<CarInsurance />} />
            <Route path="/accident-insurance" element={<AccidentInsurance />} />
            <Route path="/property-insurance" element={<PropertyInsurance />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
